// export type RadioButtonType = typeof RadioButtonThemes[number]
export enum RadioButtonType {
  Classic = 'classic',
  New = 'new'
}